module.exports = __webpack_public_path__ + "static/media/ga.e554f938.svg";